var _defs, _path, _rect, _path2, _rect2, _path3, _rect3, _path4, _path5, _polygon, _polygon2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSection128(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#128abc;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M195.27,20.5H104.5l-.23,47.33a2.5,2.5,0,0,1-2.49,2.49L48,70.39V222.77A12.74,12.74,0,0,0,60.73,235.5H195.27A12.74,12.74,0,0,0,208,222.77V33.23A12.74,12.74,0,0,0,195.27,20.5Zm.13,139.94a2.49,2.49,0,0,1-2.5,2.5h-5.17V210a2.5,2.5,0,0,1-2.5,2.5H70.91a2.5,2.5,0,0,1-2.5-2.5v-47.1H63.23a2.49,2.49,0,0,1-2.5-2.5V146a2.5,2.5,0,0,1,2.5-2.5H98.87V124.05l-8.11,4.2a2.46,2.46,0,0,1-1.14.28,2.5,2.5,0,0,1-1.15-4.72l37.81-19.57V75.85a2.5,2.5,0,0,1,3.42-2.33l22.7,9a2.5,2.5,0,0,1,0,4.64l-21.14,8.55v8.63l36.41,19.51a2.5,2.5,0,1,1-2.36,4.41l-7.81-4.18v19.49H192.9a2.5,2.5,0,0,1,2.5,2.5Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 65.73,
    y: 148.54,
    width: 33.14,
    height: 9.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.41,162.94v44.6H98.87v-44.6Zm14.71,22.89a2.5,2.5,0,1,1-5,0V175.21a2.5,2.5,0,0,1,5,0Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 157.52,
    y: 148.54,
    width: 32.88,
    height: 9.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.52,162.94v44.6h25.21v-44.6ZM173,185.83a2.5,2.5,0,1,1-5,0V175.21a2.5,2.5,0,0,1,5,0Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 120.83,
    y: 186.61,
    width: 14.47,
    height: 20.93
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128.71,108.61l-24.84,12.85v86.08h12V184.11a2.5,2.5,0,0,1,2.5-2.5H137.8a2.5,2.5,0,0,1,2.5,2.5v23.43h12.22V121.77a2.33,2.33,0,0,1,0-.38ZM128.06,158a15.36,15.36,0,1,1,15.35-15.36A15.37,15.37,0,0,1,128.06,158Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.41,142.63a10.35,10.35,0,1,1-10.35-10.35A10.37,10.37,0,0,1,138.41,142.63Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "144.75 84.84 131.28 90.29 131.28 79.52 144.75 84.84"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "99.48 23.56 99.28 65.32 52.12 65.39 67.6 51.72 99.48 23.56"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection128);
export default __webpack_public_path__ + "static/media/section128.a5f5050108ea4b4f842e1cd2f9d5177f.svg";
export { ForwardRef as ReactComponent };